<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '~~/lib/tw-utils'

const props = defineProps<{ class?: HTMLAttributes['class'] }>()
</script>

<template>
  <div :class="cn('flex flex-col-reverse sm_flex-row sm_justify-end sm_gap-x-2', props.class)">
    <slot />
  </div>
</template>
